/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для формы заказа звонка в контактах.
   */
  app.MessageToCallMeFormContactGroupView = app.CallMeFormView.extend({
    el: '#manager_call',
    formName: 'manager-call',
    initiatorSelector: '[data-open="manager_call"]',
    successAfter: function () {
      if (this.model.get('manager_id')) {
        this.initiatorSelector = '[data-manager_id=' + this.model.get('manager_id') + '].contacts-manager_call';
      }
      new app.DynamicPopupView({
        className: 'callme-send-success',
        initiator: this.$(this.initiatorSelector).length ? this.$(this.initiatorSelector) : $(this.initiatorSelector),
        content: this.popupContent
      });
    }
  });
})();

}.call(window));